import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { media } from '@clds/style-utils';

const Root = styled.div`
  ${typography.lg.regular}
  min-height: 58px;
  display: flex;
  align-items: center;
  margin-right: ${globalTheme.spacing.xs};
  padding: ${globalTheme.spacing.xs};

  @media ${media.tablet({ maxOnly: true })} {
    padding: 0 ${globalTheme.spacing.md};
  }
`;

export const Title: React.FC<React.PropsWithChildren<unknown>> = ({ children, ...rest }) => {
  return (
    <Root data-test="title-wrapper" {...rest}>
      {children}
    </Root>
  );
};
